var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumTargetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 70,
    viewBox: "0 0 67 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 39.5,
    r: 29.5,
    stroke: "#37D881",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 39.5,
    r: 17.5,
    stroke: "#37D881",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5053 38.5995C30.5602 39.149 31.0502 39.55 31.5998 39.495L40.5551 38.5997C41.1047 38.5447 41.5056 38.0547 41.4507 37.5051C41.3957 36.9556 40.9057 36.5546 40.3562 36.6096L32.3958 37.4055L31.5999 29.4452C31.545 28.8956 31.055 28.4947 30.5054 28.5496C29.9559 28.6046 29.5549 29.0946 29.6099 29.6441L30.5053 38.5995ZM53.227 10.3668L30.7263 37.8668L32.2742 39.1333L54.7749 11.6333L53.227 10.3668Z",
    fill: "#37D881"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6913 7.48438L56.8334 8.16809L57.5171 3.31011C57.5221 3.25368 57.5102 3.19704 57.4828 3.14742C57.4555 3.0978 57.414 3.05746 57.3636 3.03155C57.3132 3.00564 57.2563 2.99533 57.2 3.00195C57.1438 3.00857 57.0907 3.03181 57.0478 3.06871L53.8271 6.27288C53.4963 6.60607 53.253 7.01586 53.1188 7.46579C52.9846 7.91572 52.9637 8.39185 53.058 8.85181L53.5708 11.4307L56.1496 11.942C56.6096 12.0363 57.0857 12.0154 57.5356 11.8812C57.9856 11.747 58.3954 11.5036 58.7285 11.1728L61.9312 7.95368C61.9682 7.9106 61.9915 7.85744 61.9981 7.80101C62.0047 7.74459 61.9942 7.68749 61.9681 7.63704C61.942 7.58659 61.9014 7.5451 61.8515 7.5179C61.8017 7.4907 61.7448 7.47902 61.6883 7.48438",
    stroke: "#37D881",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumTargetIcon);
export default __webpack_public_path__ + "static/media/premium-target-icon.60796fe719e2a686707d261a4c3e8999.svg";
export { ForwardRef as ReactComponent };